import React, { useState, useEffect } from "react";

const ButtonTab = ({ handleLayoutChange, selectedLayout, updatePayPalButtonTabData, payPalButtonTabData }) => {
    const [textAboveButton, setTextAboveButton] = useState(payPalButtonTabData.text_above_button);
    const [buttonText, setButtonText] = useState(payPalButtonTabData.button_text);
    const [selectedButtonElements, setSelectedButtonElements] = useState(payPalButtonTabData.button_elements || []);
    const [selectedPaymentSystemsIcons, setSelectedPaymentSystemsIcons] = useState(payPalButtonTabData.payment_systems_icons || []);

    //Handlers Text Above Button Change
    const handleTextAboveButtonChange = (event) => {
        const value = event.target.value;
        setTextAboveButton(value);
        updatePayPalButtonTabData("text_above_button", value);
    };

    //Handlers Button Text Change
    const handleButtonTextChange = (event) => {
        const value = event.target.value;
        setButtonText(value);
        updatePayPalButtonTabData("button_text", value);
    };

    // UseEffect Button Elements Change
    useEffect(() => {
        // Sync state if payPalButtonTabData updates from outside
        if (Array.isArray(payPalButtonTabData.button_elements)) {
            setSelectedButtonElements(payPalButtonTabData.button_elements);
        } else if (typeof payPalButtonTabData.button_elements === 'string') {
            try {
            const parsed = JSON.parse(payPalButtonTabData.button_elements);
            setSelectedButtonElements(parsed);
            } catch (e) {
            // Fallback if not a valid JSON string
            const buttonElementsFromString = payPalButtonTabData.button_elements.split(',').map(item => item.trim());
            setSelectedButtonElements(buttonElementsFromString);
            }
        }
    }, [payPalButtonTabData.button_elements]); 
    // Handlers Button Elements Change
    const handleButtonElementsChange = (event) => {
        const { value, checked } = event.target;
        let updatedButtonElements = [...selectedButtonElements];
    
        if (checked) {
          if (!updatedButtonElements.includes(value)) {
            updatedButtonElements.push(value);
          }
        } else {
          updatedButtonElements = updatedButtonElements.filter(device => device !== value);
        }
    
        setSelectedButtonElements(updatedButtonElements);
        updatePayPalButtonTabData("button_elements", JSON.stringify(updatedButtonElements));
    };


    // UseEffect Payment Systems Icons Change
    useEffect(() => {
        // Sync state if payPalButtonTabData updates from outside
        if (Array.isArray(payPalButtonTabData.payment_systems_icons)) {
            setSelectedPaymentSystemsIcons(payPalButtonTabData.payment_systems_icons);
        } else if (typeof payPalButtonTabData.payment_systems_icons === 'string') {
            try {
            const parsed = JSON.parse(payPalButtonTabData.payment_systems_icons);
            setSelectedPaymentSystemsIcons(parsed);
            } catch (e) {
            // Fallback if not a valid JSON string
            const paymentSystemsIconsFromString = payPalButtonTabData.payment_systems_icons.split(',').map(item => item.trim());
            setSelectedPaymentSystemsIcons(paymentSystemsIconsFromString);
            }
        }
    }, [payPalButtonTabData.payment_systems_icons]); 
    // Handlers Payment Systems Icons Change
    const handlePaymentSystemsIconsChange = (event) => {
        const { value, checked } = event.target;
        let updatedPaymentSystemsIcons = [...selectedPaymentSystemsIcons];
    
        if (checked) {
          if (!updatedPaymentSystemsIcons.includes(value)) {
            updatedPaymentSystemsIcons.push(value);
          }
        } else {
          updatedPaymentSystemsIcons = updatedPaymentSystemsIcons.filter(device => device !== value);
        }
    
        setSelectedPaymentSystemsIcons(updatedPaymentSystemsIcons);
        updatePayPalButtonTabData("payment_systems_icons", JSON.stringify(updatedPaymentSystemsIcons));
    };

    return (
        <div className="side-baar-layout-tab">
            <span>Button</span>
            <div className="side-baar-box-header">
                <div className="box-header-row bubble-text">
                    <label>Text Above Button</label>
                    <input type="text" value={textAboveButton} onChange={handleTextAboveButtonChange} placeholder="Type Text Above Button..." />
                </div>
            </div>

           <div className="side-baar-box-header">
                <div className="box-header-row bubble-text">
                    <label>Button Text</label>
                    <input type="text" value={buttonText} onChange={handleButtonTextChange} placeholder="Type Button Text..." />
                </div>
            </div>

            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <h6 className="h6-tage">Button Rlements</h6>
                    <ul className="pages-list-two">
                        <li>
                            <div className="form-group">
                                <input id="button_text" type="checkbox" value="Button Text" checked={selectedButtonElements.includes("Button Text")} onChange={handleButtonElementsChange} />
                                <label for="button_text">Button Text</label>
                            </div>
                        </li>
                        <li>
                            <div className="form-group">
                                <input id="button_paypal_icon" type="checkbox" value="Paypal Icon" checked={selectedButtonElements.includes("Paypal Icon")} onChange={handleButtonElementsChange} />
                                <label for="button_paypal_icon">Paypal Icon</label>
                            </div>
                        </li>
                        <li>
                            <div className="form-group">
                                <input id="button_paypal_text" type="checkbox" value="Paypal Text" checked={selectedButtonElements.includes("Paypal Text")} onChange={handleButtonElementsChange} />
                                <label for="button_paypal_text">Paypal Text</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <h6 className="h6-tage">Payment Systems Icons</h6>
                    <ul className="pages-list-two">
                        <li>
                            <div className="form-group">
                                <input id="button_visa" type="checkbox" value="Visa" checked={selectedPaymentSystemsIcons.includes("Visa")} onChange={handlePaymentSystemsIconsChange} />
                                <label for="button_visa">Visa</label>
                            </div>
                        </li>
                        <li>
                            <div className="form-group">
                                <input id="button_mastercard" type="checkbox" value="Mastercard" checked={selectedPaymentSystemsIcons.includes("Mastercard")} onChange={handlePaymentSystemsIconsChange} />
                                <label for="button_mastercard">Mastercard</label>
                            </div>
                        </li>
                        <li>
                            <div className="form-group">
                                <input id="button_amex" type="checkbox" value="Amex" checked={selectedPaymentSystemsIcons.includes("Amex")} onChange={handlePaymentSystemsIconsChange} />
                                <label for="button_amex">Amex</label>
                            </div>
                        </li>
                        <li>
                            <div className="form-group">
                                <input id="button_discover" type="checkbox" value="Discover" checked={selectedPaymentSystemsIcons.includes("Discover")} onChange={handlePaymentSystemsIconsChange} />
                                <label for="button_discover">Discover</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    );
};

export default ButtonTab;